var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.165,
    height: 69.292,
    viewBox: "0 0 56.165 69.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.41,
    x2: 0.5,
    y2: 2.248,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.302
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ios-stop",
    transform: "translate(0.002 -0.167)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_242",
    "data-name": "Ellipse 242",
    cx: 2.808,
    cy: 2.814,
    rx: 2.808,
    ry: 2.814,
    transform: "translate(25.273 63.83)",
    fill: "#f77c7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M23.6,70.279C10.218,69.335,0,64.226,0,58.068,0,51.238,12.573,45.7,28.081,45.7s28.081,5.538,28.081,12.367c0,6.14-10.162,11.232-23.485,12.2-3.894.8-4.6,2.64-4.6,2.64a7.949,7.949,0,0,0-4.48-2.629Z",
    transform: "translate(0 -10.016)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M23.6,55.969a28.081,28.081,0,1,1,9.076-.019,8.707,8.707,0,0,0-4.6,6S26.307,56.919,23.6,55.969Z",
    fill: "#f77c7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "apple",
    transform: "translate(260.907 -535.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3335",
    "data-name": "Path 3335",
    d: "M-220.492,593.032a2.734,2.734,0,0,1-1.214.321h-.023c-1.214,0-2.244-1.328-3-2.5a10.9,10.9,0,0,1-1.832-7.466,5.269,5.269,0,0,1,.687-1.924,4.663,4.663,0,0,1,3.733-2.267,5.26,5.26,0,0,1,1.924.435,5.375,5.375,0,0,0,1.878.412,4.842,4.842,0,0,0,1.7-.389,5.271,5.271,0,0,1,2.061-.458,4.432,4.432,0,0,1,3.023,1.374l.046.046-.046.046a4.644,4.644,0,0,0-1.649,2.2,4.864,4.864,0,0,0,2.336,5.954l.046.023-.023.046a13.5,13.5,0,0,1-1.031,1.855c-.8,1.214-1.878,2.634-3.069,2.634h-.023a2.639,2.639,0,0,1-1.191-.321,4.513,4.513,0,0,0-2.13-.5h-.023a4.492,4.492,0,0,0-2.175.479Z",
    transform: "translate(-13.255 -21.923)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Apple-2",
    "data-name": "Apple",
    transform: "translate(-242.724 550.765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Path_",
    transform: "translate(9.503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3336",
    "data-name": "Path 3336",
    d: "M-196.83,556.659a.692.692,0,0,1-.366-.115.564.564,0,0,1-.206-.435,5.357,5.357,0,0,1,4.26-5.336.613.613,0,0,1,.481.115.564.564,0,0,1,.206.435,5.357,5.357,0,0,1-4.26,5.336Zm3.16-4.534a4.162,4.162,0,0,0-2.542,3.183,4.162,4.162,0,0,0,2.542-3.184Z",
    transform: "translate(197.404 -550.765)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Path_2",
    transform: "translate(0 5.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3337",
    "data-name": "Path 3337",
    d: "M-224.541,592.913a6.257,6.257,0,0,1-2.7-.572,3.918,3.918,0,0,0-1.58-.389,3.578,3.578,0,0,0-1.58.389,6.259,6.259,0,0,1-2.7.572c-2.13,0-5.794-5.221-5.794-10.557,0-4.992,3.115-6.756,5.794-6.756a5.816,5.816,0,0,1,2.267.5,5.329,5.329,0,0,0,2.015.458,5.328,5.328,0,0,0,2.015-.458,6.037,6.037,0,0,1,2.29-.5,5.786,5.786,0,0,1,4.191,1.809.531.531,0,0,1,.137.481.667.667,0,0,1-.275.412,4.138,4.138,0,0,0-2.084,3.572,3.95,3.95,0,0,0,2.5,3.733.571.571,0,0,1,.321.71C-220.763,589.546-222.8,592.913-224.541,592.913Zm-4.282-2.084a4.738,4.738,0,0,1,1.992.458,5.22,5.22,0,0,0,2.267.481c.71,0,2.427-2.061,3.573-5.313a5.12,5.12,0,0,1-2.725-4.58h0a5.322,5.322,0,0,1,2.038-4.122,4.567,4.567,0,0,0-2.863-.985h-.023a4.8,4.8,0,0,0-1.855.435,6.162,6.162,0,0,1-2.427.527,6.258,6.258,0,0,1-2.427-.527,4.8,4.8,0,0,0-1.855-.435c-.779,0-4.649.275-4.649,5.611,0,5.175,3.527,9.412,4.649,9.412a5.224,5.224,0,0,0,2.267-.481,4.773,4.773,0,0,1,2.037-.481Z",
    transform: "translate(238.9 -575.6)",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.d1af6703ce153933734082168605bce3.svg";
export { ForwardRef as ReactComponent };